import { Contact } from './types/Contact';

export interface ResolvedContactName {
  firstName: string;
  lastName: string;
  displayName: string;
}

export const resolveContactName = (
  contact: Pick<Contact, 'name' | 'firstName' | 'lastName'>,
): ResolvedContactName => {
  const firstName = contact.firstName?.trim() ?? '';
  const lastName = contact.lastName?.trim() ?? '';

  if (firstName || lastName) {
    const displayName = [firstName, lastName].filter(Boolean).join(' ').trim();
    return {
      firstName,
      lastName,
      displayName: displayName || contact.name?.trim() || '',
    };
  }

  const name = contact.name?.trim() ?? '';
  if (!name) {
    return {
      firstName: '',
      lastName: '',
      displayName: '',
    };
  }

  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return {
      firstName: parts[0],
      lastName: '',
      displayName: name,
    };
  }

  return {
    firstName: parts[0],
    lastName: parts.slice(1).join(' '),
    displayName: name,
  };
};

export const withResolvedContactName = (contact: Contact): Contact => {
  const resolved = resolveContactName(contact);
  const hasFirstName = Boolean(contact.firstName?.trim());
  const hasLastName = Boolean(contact.lastName?.trim());

  return {
    ...contact,
    firstName: hasFirstName ? contact.firstName : (resolved.firstName || undefined),
    lastName: hasLastName ? contact.lastName : (resolved.lastName || undefined),
    name: contact.name?.trim() || resolved.displayName,
  };
};
